import React from 'react';
import PropTypes from 'prop-types';
import { makeDesignationString } from '../helpers.jsx';
import { connectToJSContext, RA_73_STERILIZE_HTML_STRING } from '../utils.jsx';

const ProfileDesignations = (props) => {
    if (!props.designationString) {
        return null;
    }

    const designationEl = (
        <span
            dangerouslySetInnerHTML={{
                __html: RA_73_STERILIZE_HTML_STRING(props.designationString)
            }}
        />
    );

    return props.isInline ?
        <span>
            , {designationEl}
        </span> :
        <p className="c-profile__designations">
            {designationEl}
        </p>;
};

ProfileDesignations.protoTypes = {
    designationString: PropTypes.string,
    isInline: PropTypes.bool
};

const mapStateToProps = ({ profile, categories }) => {
    return {
        designationString: makeDesignationString(
            profile.designations,
            categories.designations,
            profile.additional_designations
        )
    };
};

export default connectToJSContext(mapStateToProps)(ProfileDesignations);



// WEBPACK FOOTER //
// ./components/profile/profile_designations.jsx